module.exports = __webpack_public_path__ + "static/ceremony-timeline-63aaf6328b16d3a0478c18efe8f1a49e.jpg";